import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon, IconSizesEnum } from '../icon/icon.component';

@Component({
  selector: 'i2g-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements OnInit {
  @Input() loaderText;
  @Input() loaderClass;
  @Input() horizontal = false;

  spinnerIcon: IIcon;

  ngOnInit() {
    this.spinnerIcon = {
      name: 'i2g-loader',
      size: IconSizesEnum.custom,
    };
  }
}
